import { Link, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom
import { classNames } from 'primereact/utils';
import { forwardRef, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { AppTopbarRef } from '../types/types';
import { LayoutContext } from './context/LayoutContext';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { OverlayPanel } from 'primereact/overlaypanel'
import { Avatar } from 'primereact/avatar';
import VoiceNavigation from "../components/VoiceNavigation";
import { Sidebar } from 'primereact/sidebar';
import ADPTntService from '../services/admin/ADPTntService';
import { Dropdown } from 'primereact/dropdown';
import logo from '../assets/images/logo-lix.png';
import ADPUsrService from '../services/admin/ADPUsrService';
import ADPUsrtntService from '../services/admin/ADPUsrtntService';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalInstance } from '../utils/msalConfig';

interface DropdownItem {
    name: string;
    code: string;
    facilityCode: string;
    fullName: string;
}

const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
    const { layoutConfig, layoutState, onMenuToggle, showProfileSidebar } = useContext(LayoutContext);
    const menubuttonRef = useRef(null);
    const topbarmenuRef = useRef(null);
    const topbarmenubuttonRef = useRef(null);
    const facilityName = localStorage.getItem('clientState') ? JSON.parse(localStorage.getItem('clientState') as string).facilityFullName : '';
    const userName = localStorage.getItem('clientState') ? JSON.parse(localStorage.getItem('clientState') as string).fullName : '';
    const facilityCode = localStorage.getItem('clientState') ? JSON.parse(localStorage.getItem('clientState') as string).facilityCode : '';
    const userId = localStorage.getItem('clientState') ? JSON.parse(localStorage.getItem('clientState') as string).userId : '';
    const email = localStorage.getItem('clientState') ? JSON.parse(localStorage.getItem('clientState') as string).userData.email : '';

    const overlayRef = useRef<OverlayPanel>(null);
    const opRef = useRef<OverlayPanel>(null);
    const profileImage = localStorage.getItem("profileImage") || "";
    const overlayTranslate = useRef<OverlayPanel>(null);
    const { i18n } = useTranslation('common');
    const [currentLanguage, setCurrentLanguage] = useState({
        code: 'en',
        label: 'EN',
        flag: '/demo/images/flag/united-kingdom.png',
    });

    const [visibleFullScreen, setVisibleFullScreen] = useState(false);

    const [facilityDropdown, setFacilityDropdown] = useState<DropdownItem[]>([]);
    const facilityDropdownOptions = useMemo(() => facilityDropdown, [facilityDropdown]);

    const [selectFacilityCode, setSelectFacilityCode] = useState('');



    const languages = [
        { code: 'en', label: 'English', flag: '/demo/images/flag/united-kingdom.png' },
        { code: 'id', label: 'Indonesia', flag: '/demo/images/flag/indonesia.png' },
        { code: 'cn', label: 'Chinese', flag: '/demo/images/flag/china.png' },
        { code: 'ar', label: 'Arabic', flag: '/demo/images/flag/arab.png' },
    ];

    const changeLanguage = (lang: { code: string; label: string; flag: string }) => {
        i18n.changeLanguage(lang.code)
        setCurrentLanguage(lang);
        overlayTranslate.current?.hide(); // Close the dropdown
    };

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
        topbarmenu: topbarmenuRef.current,
        topbarmenubutton: topbarmenubuttonRef.current
    }));

    const navigate = useNavigate();

    // const handleLogout = async () => {
    //     try {
    //         await msalInstance.logoutRedirect({
    //             postLogoutRedirectUri: process.env.NODE_ENV === "development"
    //                 ? "http://localhost:4000/login"
    //                 : "https://easiqr.novamed-technology.com/login",
    //         });

    //         localStorage.removeItem('clientState');
    //         localStorage.removeItem('roleRouteMappings');
    //         localStorage.removeItem('programRoleId');
    //         sessionStorage.clear();

    //     } catch (error) {
    //         console.error("Logout failed:", error);
    //     }
    // };

    const handleLogout = async () => {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/login";
    };


    const [isModalVisible, setIsModalVisible] = useState(false);
    // Function to handle image click
    const handleImageClick = (event: React.MouseEvent<HTMLImageElement>) => {
        // Open the modal when image is clicked
        if (opRef.current) {
            opRef.current.toggle(event); // Show overlay
        }
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalVisible(false); // Close the modal
    };

    const handleDropdownChange = (e: any) => {
        const { id, value } = e.target;
        // setFormData({
        //     ...formData,
        //     [id]: value
        // });
    };

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        if (userId && selectFacilityCode) {
            ADPUsrService.changeTenant(userId, selectFacilityCode).then((data) => {
                setVisibleFullScreen(false);

                localStorage.removeItem("clientState");
                localStorage.removeItem("roleRouteMappings");
                localStorage.removeItem("programRoleId");

                data.success = {
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Record Already Save',
                    life: 3000
                };

                data.error = {
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error',
                    life: 3000
                };

                data.warn = {
                    severity: 'warn',
                    summary: 'Warning',
                    detail: 'Warning',
                    life: 3000
                };

                data.required = {
                    severity: 'warn',
                    summary: 'Warning',
                    detail: 'Please Check Required Field ',
                    life: 3000
                };

                localStorage.setItem('clientState', JSON.stringify(data));
                localStorage.setItem("roleRouteMappings", JSON.stringify(data.menuTree));
                localStorage.setItem('programRoleId', (data.programRoleId));
                window.location.href = "/landing-page";
            });
        }

    };

    useEffect(() => {
        if (visibleFullScreen) {
            ADPUsrtntService.getItemsExcludeFacilityCode(facilityCode, userId).then((data) => {
                setFacilityDropdown(data);
            });
        }
    }, [visibleFullScreen]);

    return (
        <div className="layout-topbar">

            <Sidebar
                visible={visibleFullScreen}
                onHide={() => setVisibleFullScreen(false)}
                baseZIndex={1000}
                fullScreen
                showCloseIcon={false}
            >

                <div className="tenant-container" >
                    <form onSubmit={handleLogin} className="tenant-form">
                        <div style={{ textAlign: 'center' }}>
                            <img src={logo} alt="Logo" style={{ width: '250px', height: 'auto' }} />
                        </div>
                        <h3>{process.env.REACT_APP_SYSTEM_NAME}</h3>
                        <div className="form-group">
                            <label style={{ fontSize: "20px" }}>Facility</label>
                        </div>
                        <div className="form-group">
                            <Dropdown
                                id="selectFacilityCode"
                                value={selectFacilityCode}
                                onChange={(e) => setSelectFacilityCode(e.value)}
                                options={facilityDropdownOptions}
                                optionLabel="facilityCodeHasOne.fullName"
                                placeholder="Select One"
                                optionValue="facilityCode"
                                className="w-full"
                            />
                        </div>
                        <div className="form-group">
                            <button
                                className='tenant-button'
                                type="submit"
                            >
                                Change Tenant
                            </button>
                        </div>
                        <div className="form-group">
                            <Button
                                className='login-button'
                                color="primary"
                                onClick={() => setVisibleFullScreen(false)}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form>
                </div>
            </Sidebar>


            <button ref={menubuttonRef} type="button" className="p-link layout-menu-button layout-topbar-button" onClick={onMenuToggle}>
                <i className="pi pi-bars" />
            </button>

            <Link to="/landing-page" className="layout-topbar-logo">
                <img
                    src={`/layout/images/logo-lix.png`}
                    alt="logo"
                    style={{ width: '40px', height: 'auto' }}
                />
                <span>EasiQR</span>
            </Link>

            <button ref={topbarmenubuttonRef} type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={showProfileSidebar}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <div
                ref={topbarmenuRef}
                className={classNames('layout-topbar-menu', {
                    'layout-topbar-menu-mobile-active': layoutState.profileSidebarVisible
                })}
            >
                {/* Dekstop Menu Button */
                    !layoutState.profileSidebarVisible && (
                        <>
                            <div className='flex flex-col gap-4'>
                                <div className='flex align-items-center'>
                                    {/* <VoiceNavigation /> */}
                                </div>

                                <div className='flex items-center'>
                                    {/* Your second div content here */}
                                </div>
                                <div className='flex items-center'>
                                    {/* Your second div content here */}
                                </div>
                            </div>

                            <div className="relative flex align-items-center">
                                {/* Settings Button */}
                                <button
                                    type="button"
                                    className="p-link layout-topbar-user"
                                    onClick={(e) => overlayRef.current?.toggle(e)}
                                >
                                     {userName}
                                </button>

                                {/* Modern Dropdown Menu */}
                                <OverlayPanel ref={overlayRef} className="p-0 shadow-xl rounded-lg w-56 bg-white border">
                                    <nav className="list-none m-0 p-0">
                                        <button
                                            type="button"
                                            className="p-link layout-topbar-button flex items-center gap-3 px-5 py-3 text-gray-700 hover:bg-gray-100 transition duration-300"
                                            onClick={(e) => {
                                                navigate("/admin/profile");
                                                overlayRef.current?.hide();
                                            }}

                                        >
                                            <i className="pi pi-user text-lg"></i>
                                            <span>Profile</span>
                                        </button>
                                        {/* Switch Tenant Button */}
                                        {/* <hr className="border-gray-200" />
                                        <button
                                            type="button"
                                            className="p-link layout-topbar-button flex items-center gap-3 px-5 py-3 text-gray-700 hover:bg-gray-100 transition duration-300"
                                            onClick={(e) => {
                                                setVisibleFullScreen(true);
                                                overlayRef.current?.hide();
                                            }}
                                        >
                                            <i className="pi pi-th-large text-lg"></i>
                                            <span>Switch Tanent</span>
                                        </button> */}
                                        <hr className="border-gray-200" />
                                        <button
                                            type="button"
                                            className="p-link layout-topbar-button flex items-center gap-3 px-5 py-3 text-red-500 hover:bg-red-50 transition duration-300 rounded-b-lg"
                                            onClick={handleLogout}
                                        >
                                            <i className="pi pi-sign-out text-lg"></i>
                                            <span>Logout</span>
                                        </button>

                                    </nav>
                                </OverlayPanel>
                            </div>
                            <div className="relative">
                                <Avatar
                                    image={"https://www.w3schools.com/howto/img_avatar2.png"}
                                    size="large"
                                    shape="circle"
                                    className="p-link layout-topbar-button align-items-center"
                                    style={{ width: "40px", height: "40px" }}
                                // onClick={handleImageClick}
                                />
                                <OverlayPanel ref={opRef} appendTo={document.body} showCloseIcon>
                                    <img
                                        src={profileImage}
                                        alt="User Preview"
                                        style={{ maxWidth: "300px", borderRadius: "10px" }}
                                    />
                                </OverlayPanel>

                            </div>
                            {/* <div className="relative">
                                <Button
                                    className="p-link layout-topbar-button"
                                    onClick={(e) => overlayTranslate.current?.toggle(e)}
                                >
                                    <img
                                        src={currentLanguage.flag}
                                        alt={currentLanguage.label}
                                        style={{ width: "25px", height: "25px" }}
                                    />
                                </Button>

                                <OverlayPanel ref={overlayTranslate} className="p-0">
                                    <ul className="list-none m-0 p-0">
                                        {languages.map((lang) => (
                                            <li
                                                key={lang.code}
                                                onClick={() => changeLanguage(lang)}
                                                className="flex aligns-items-center px-4 py-2 cursor-pointer hover:bg-gray-200"
                                            >
                                                <Avatar
                                                    image={lang.flag}
                                                    shape='circle'
                                                />
                                                <span className="flex px-2">{lang.label}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </OverlayPanel>
                            </div> */}
                        </>

                    )}

                {/* Mobile Menu Button */
                    layoutState.profileSidebarVisible && (
                        <div className="p-0 shadow-xl rounded-lg w-56 bg-white border">
                            <nav className="list-none m-0 p-0">
                                <Button
                                    type="button"
                                    className="p-link layout-topbar-button flex items-center gap-3 px-5 py-2 text-gray-700 hover:bg-gray-100 transition duration-300"
                                    onClick={(e) => {
                                        navigate("/admin/profile");
                                        overlayRef.current?.hide();
                                    }}
                                >
                                    <Avatar
                                        image={profileImage || "https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png"}
                                        size="normal"
                                        shape="circle"
                                        style={{ width: "32px", height: "32px" }}
                                    />
                                    <span>Profile</span>
                                </Button>

                                {/* <Button
                                    type="button"
                                    className="p-link layout-topbar-button flex items-center gap-3 px-5 py-3 text-gray-700 hover:bg-gray-100 transition duration-300"
                                    onClick={(e) => {
                                        setVisibleFullScreen(true);
                                        overlayRef.current?.hide();
                                    }}

                                >
                                    <Avatar
                                        image="https://cdn-icons-png.flaticon.com/512/1055/1055687.png"
                                        size="normal"
                                        shape="circle"
                                        style={{ width: "32px", height: "32px" }}
                                    />
                                    <span>Switch Tanent</span>
                                </Button> */}

                                {/* <Button
                                    type="button"
                                    className="p-link layout-topbar-button flex items-center gap-3 px-5 py-2 text-gray-700 hover:bg-gray-100 transition duration-300"
                                    onClick={(e) => overlayTranslate.current?.toggle(e)}
                                >
                                    <img
                                        src={currentLanguage.flag}
                                        alt={currentLanguage.label}
                                        style={{ width: "32px", height: "32px" }}
                                    />
                                    <span>Language</span>
                                </Button> */}

                                {/* Dropdown Menu */}
                                <OverlayPanel ref={overlayTranslate} className="p-0">
                                    <ul className="list-none m-0 p-0">
                                        {languages.map((lang) => (
                                            <li
                                                key={lang.code}
                                                onClick={() => changeLanguage(lang)}
                                                className="flex aligns-items-center px-4 py-2 cursor-pointer hover:bg-gray-200"
                                            >
                                                <Avatar
                                                    image={lang.flag}
                                                    shape='circle'
                                                />
                                                <span className="flex px-2">{lang.label}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </OverlayPanel>

                                <hr className="border-gray-200" />
                                <button
                                    type="button"
                                    className="p-link layout-topbar-button flex items-center gap-3 px-5 py-3 text-red-500 hover:bg-red-50 transition duration-300 rounded-b-lg"
                                    onClick={handleLogout}
                                >
                                    <i className="pi pi-sign-out text-lg"></i>
                                    <span>Logout</span>
                                </button>

                            </nav>
                        </div>
                    )}
            </div>

        </div>


    );
});

AppTopbar.displayName = 'AppTopbar';

export default AppTopbar;
